import Image from "next/image"
import type { BuyNowEventLabel, StakingEventLabel } from "services/analytics"
import { trackBuyNowClick, trackStakingClick } from "services/analytics"

import { Links } from "config/links"

import { Box } from "components/shared/box"
import { OpenSea } from "components/shared/icons/opensea"
import { Button } from "components/shared/landing/button"
import { Link } from "components/shared/link"
import { Text } from "components/shared/text"

const benefits = [
  { icon: "/images/sections/nft-assets-section/icon_1.svg", text: "Early access to the game" },
  { icon: "/images/sections/nft-assets-section/icon_2.svg", text: "X2 Manufacturing speed" },
  { icon: "/images/sections/nft-assets-section/icon_3.svg", text: "+70% Manufacturing limit" },
  { icon: "/images/sections/nft-assets-section/icon_4.svg", text: "Limited holders packs" },
  { icon: "/images/sections/nft-assets-section/icon_5.svg", text: "Create initial supply" },
]

type NftSectionProps = {
  hideCollectionInfo?: boolean
  hideStakeButton?: boolean
  largeList?: boolean
  eventsLabel?: BuyNowEventLabel | StakingEventLabel
}

export function NftAssetsSection({
  eventsLabel,
  hideCollectionInfo = false,
  hideStakeButton = false,
  largeList = false,
}: NftSectionProps) {
  return (
    <Box className="gap-12 md:flex-row">
      <Box className="flex-1">
        <Box className="flex-1 max-w-[450px] mx-auto w-full animate-zoom">
          <Image
            src="/images/sections/nft-assets-section/bot.png"
            width={520}
            height={520}
            layout={"responsive"}
            alt="bot"
          />
        </Box>
      </Box>
      <Box className="flex-1 mt-2 md:mt-0">
        {!hideCollectionInfo && (
          <>
            <Text className="text-center md:text-left text-h4 md:text-h3">
              <span className="text-primary">10.000</span> Genesis Bots
            </Text>
            <Text className="mt-4 opacity-80">
              Genesis is the very first generation of Bots. Produced by 3 metagalactic corporations to dominate in the
              technocratic universe, Genesis will be the ones to spread genes for all upcoming Cryptobots generations in
              the years to come.
            </Text>
            <Text className="mt-8 mb-4 opacity-80 text-center md:text-left" weight="bold">
              Unique Genesis Cryptobots Benefits:
            </Text>
          </>
        )}
        <Box full className="items-center md:items-start">
          <Box className="w-fit">
            {benefits.map(({ icon, text }, ind) => (
              <Box row className={`items-center ${largeList ? "mb-8" : "mb-2"}`} key={ind}>
                <Image src={icon} height={32} width={32} alt="icon" />
                <Text
                  size={largeList ? "h4" : "sm"}
                  className={`${largeList ? "" : "opacity-80"} ml-3`}
                  weight="regular"
                >
                  {text}
                </Text>
              </Box>
            ))}
          </Box>
        </Box>
        <Box className="gap-7 md:gap-10 mt-6 md:flex-row items-center">
          <Link
            href={Links.OPENSEA_GENESIS}
            target="_blank"
            withRedirect
            onClick={() => (eventsLabel ? trackBuyNowClick(eventsLabel) : true)}
          >
            <Button size="lg" className="uppercase w-[200px]">
              <OpenSea w={20} h={20} className="mr-1" />
              Buy now
            </Button>
          </Link>
          {!hideStakeButton && (
            <Link
              href={Links.STAKING}
              target="_blank"
              withRedirect
              onClick={() => (eventsLabel ? trackStakingClick(eventsLabel as StakingEventLabel) : true)}
            >
              <Button size="lg" className="uppercase w-[200px]" type="secondary">
                Stake my bots
              </Button>
            </Link>
          )}
        </Box>
      </Box>
    </Box>
  )
}
